import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  template: require('./vehicle.actions.component.html')
})
export class VehicleActionsComponent {
  @Input() record: any;

  @Output() onEditClick   : EventEmitter<any> = new EventEmitter();
  @Output() onBookingClick: EventEmitter<any> = new EventEmitter();
  @Output() onInvoiceClick: EventEmitter<any> = new EventEmitter();
}